export default "__VITE_ASSET__CqT7VrPq__"